<valio-cx-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async" [headerNavigation]="true" [cart]="valioCart$ | async">
</valio-cx-navigation-ui>
